module.exports = __webpack_public_path__ + "assets/img/icon2-menu2.c9db987e.svg";